import { clsx } from 'clsx';
import { ALPHABET } from '~/common/helpers';
import { ObjectsByLetter } from '~/connect/types';

type Props<T> = {
  getLetterKey: (letter: string) => string;
  itemsByLetter: ObjectsByLetter<T>;
};
const LetterList = <T,>({ itemsByLetter, getLetterKey }: Props<T>) => {
  return (
    <div className='bg-neutral-grey-2 text-center h-100'>
      {ALPHABET.map((letter) => (
        <a
          key={letter}
          role='button'
          href={`#${getLetterKey(letter)}`}
          className={clsx('px-2 d-block', {
            'text-title-color': itemsByLetter[letter]?.length,
            'text-neutral-grey-5': !itemsByLetter[letter]?.length,
          })}
        >
          {letter}
        </a>
      ))}
    </div>
  );
};

export default LetterList;
